import * as tslib_1 from "tslib";
import { ElementRef, EventEmitter, OnDestroy, OnInit, Renderer2, Type } from '@angular/core';
import { Subject } from 'rxjs';
import { CsAgGridJsScriptHandlerService } from '@app/shared/cs-ag-grid-js/cs-ag-grid-js-script-handler.service';
import { CsAgGridJsAngularComponentResolverService } from '@app/shared/cs-ag-grid-js/cs-ag-grid-js-angular-component-resolver.service';
import { environment } from '../../../environments/environment';
import cloneDeep from 'lodash.clonedeep';
var CsAgGridJsComponent = /** @class */ (function () {
    function CsAgGridJsComponent(_scriptHandler, _componentResolver, renderer) {
        var _this = this;
        this._scriptHandler = _scriptHandler;
        this._componentResolver = _componentResolver;
        this.renderer = renderer;
        this.onGridInit = new EventEmitter();
        this.onGridDataLoad = new EventEmitter();
        this.onAllRowSelection = new EventEmitter();
        this.onRowSelection = new EventEmitter();
        // @Output() sendParentNode = new EventEmitter()
        this.filterWidthChangeEvent = new Subject();
        this.appliedFilter = [];
        this.searchText = '';
        this.paginationParams = {};
        this.gridLayout = 'autoHeight';
        this.isDataLoading = true;
        this.gridApiMap = new Map();
        this.swapRows = function (event) {
            if (!event.node
                || !event.overNode
                || !event.vDirection
                || (event.node.id === event.overNode.id)) {
                return;
            }
            requestAnimationFrame(function () {
                var draggedRowElement = _this.grid.nativeElement.querySelector("[row-id=\"" + event.node.id + "\"]");
                var overRowElement = _this.grid.nativeElement.querySelector("[row-id=\"" + event.overNode.id + "\"]");
                var draggingRowIndex = draggedRowElement.getAttribute('row-index');
                var overRowIndex = overRowElement.getAttribute('row-index');
                if ((event.vDirection === 'down' && (draggingRowIndex < overRowIndex))
                    || (event.vDirection === 'up' && (draggingRowIndex > overRowIndex))) {
                    var rowHeight = event.node.rowHeight;
                    var draggingRowPos = +draggingRowIndex * rowHeight;
                    var overRowPos = +overRowIndex * rowHeight;
                    _this.renderer.setAttribute(draggedRowElement, 'row-index', overRowIndex);
                    _this.renderer.setAttribute(overRowElement, 'row-index', draggingRowIndex);
                    _this.renderer.setStyle(draggedRowElement, 'transform', "translateY(" + overRowPos + "px)");
                    _this.renderer.setStyle(overRowElement, 'transform', "translateY(" + (draggingRowPos) + "px)");
                    _this.updateSwappingRowClasses(event, draggedRowElement, +overRowIndex);
                    _this.updateSwappingRowClasses(event, overRowElement, +draggingRowIndex);
                    event.node.data['swappedOrder'] = +overRowIndex;
                    event.overNode.data['swappedOrder'] = +draggingRowIndex;
                }
            });
        };
        this.getDisplayedRowNodes = function (api) {
            return api.getRenderedNodes();
        };
        this.getSelectedRows = function () {
            return _this.getDisplayedRowNodes(_this.gridApi)
                .filter(function (rowNode) { return rowNode.isSelected(); })
                .map(function (rowNode) { return rowNode.data; });
        };
        this.getAddOnData = function () {
            return _this.gridListAddOnData || null;
        };
        this.showOrHideNoRowsOverlay = function (show) { return _this.gridApi[show ? 'showNoRowsOverlay' : 'hideOverlay'](); };
        this.refreshGridData = function () {
            _this.showOrHideNoRowsOverlay(false);
            if (_this.isCSRMEnabled) {
                _this.setCSRMData();
            }
            else {
                _this.gridApi.refreshServerSide({ route: [], purge: true });
                _this.gridApi.setGridOption('serverSideDatasource', _this.dataSource);
            }
            _this.resetSelectedRows();
        };
        this.resetPagination = function () {
            if (_this.isPagination) {
                _this.goToPage(1);
                _this.totalRecords = null;
                _this.isDataLoading = true;
            }
        };
    }
    CsAgGridJsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._scriptHandler.loadAgGridScript()];
                    case 1:
                        _a.sent();
                        this.cloneConfig();
                        this.setConfig();
                        this.setGridOptions();
                        this.setGridLicense();
                        this.createGrid();
                        this.setCSRMData();
                        return [2 /*return*/];
                }
            });
        });
    };
    CsAgGridJsComponent.prototype.cloneConfig = function () {
        this.config = cloneDeep(this.config);
    };
    CsAgGridJsComponent.prototype.setConfig = function () {
        if (this.config.gridConfig.rowReOrder) {
            this.config.gridConfig.colDefs.unshift({
                field: 'row_drag',
                headerName: '',
                rowDrag: true,
                minWidth: 48,
                maxWidth: 48,
            });
        }
        var dataKeys = this.config.gridConfig.dataResKeys;
        this.config.gridConfig.dataResKeys = {
            countKey: dataKeys ? (dataKeys['countKey'] || 'count') : 'count',
            dataKey: dataKeys ? (dataKeys['dataKey'] || 'data') : 'data'
        };
        this.appliedFilter = this.config.hideFilterPanel ? [] : (this.config.filterPanelConfig['appliedFilter'] || []);
        this.filterWidthChangeEvent.next(this.appliedFilter);
        this.paginationParams['pageSize'] = this.isPagination ? (this.config.gridConfig.rowsPerPage || 5) : null;
    };
    CsAgGridJsComponent.prototype.setGridOptions = function () {
        var _this = this;
        this.gridOptions = {
            components: tslib_1.__assign({}, this._componentResolver.csAgCustomComponents(), this.resolvedAngularComponents()),
            // Note: It will be enabled (or) handled based on future spec, if required.
            // selectionColumnDef: {
            //     pinned: true
            // },
            defaultColDef: {
                flex: 1,
                suppressHeaderMenuButton: true,
                suppressHeaderContextMenu: true,
                sortable: false,
                unSortIcon: true,
                wrapText: this.config.gridConfig.wrapText !== false,
                autoHeight: this.config.gridConfig.wrapText !== false,
                wrapHeaderText: this.config.gridConfig.wrapHeaderText !== false,
                autoHeaderHeight: this.config.gridConfig.wrapHeaderText !== false,
                enableCellChangeFlash: true,
                resizable: this.config.gridConfig.isColumnResizable === true
            },
            columnDefs: this.config.gridConfig.colDefs,
            tooltipShowDelay: this.config.gridConfig.tooltipShowDelay,
            tooltipShowMode: this.config.gridConfig.tooltipShowMode,
            domLayout: 'autoHeight',
            suppressMovableColumns: true,
            rowClass: this.focusEnablingClass,
            suppressCellFocus: this.config.gridConfig.cellFocus !== true,
            suppressServerSideFullWidthLoadingRow: true,
            masterDetail: !!this.config.gridConfig.enableDetailGrid,
            suppressContextMenu: true,
            scrollbarWidth: 4,
            noRowsOverlayComponent: 'noRowsOverlay',
            suppressMoveWhenRowDragging: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
            blockLoadDebounceMillis: 500,
            rowGroupPanelShow: this.config.gridConfig.enableRowGroupPanel ? 'always' : 'never',
            // keepDetailRows: true,
            // keepDetailRowsCount: 1,
            // Note: Below, will be enabled (or) handled based on the future spec, if required.
            // suppressCsvExport: true,
            // suppressExcelExport: true,
            // rowDragMultiRow: true,
            // rowDragEntireRow: true,
            // detailRowAutoHeight: true,
            onGridSizeChanged: function (event) { return _this.updateDomLayout(); },
            onCellClicked: function (params) { return _this.onOpenChildGrid(_this.config.gridConfig.isCollapseOtherParents, params); },
            onModelUpdated: function (event) { return _this.updateDomLayout(); },
            onRowDragMove: function (event) { return _this.swapRows(event); },
            onDragStopped: function (event) { return _this.onRowDropped(event); },
            onRowSelected: function (event) { return _this.rowSelection(event); },
            onSelectionChanged: function (event) { return _this.allRowSelection(event); },
            onSortChanged: function (event) { return _this.resetSelectedRows(); },
            onCellFocused: this.config.gridConfig.onCellKeyDown
        };
        this.setServerSideProps();
        this.setPaginationProps();
        this.setRowSelectionConfig();
        this.setDetailGridConfig();
    };
    CsAgGridJsComponent.prototype.onOpenChildGrid = function (collapse, params) {
        var _this = this;
        // only act if expand/collapse icon clicked
        if (collapse && params.colDef.cellRenderer === 'detailCellRenderer' && params.node.master) {
            setTimeout(function () {
                if (params.node.expanded) {
                    _this.gridApi.forEachNode(function (node) {
                        if (node !== params.node && node.expanded) {
                            node.setExpanded(false); // collapse others
                            node['expandedColId'] = null;
                        }
                    });
                }
            });
        }
    };
    CsAgGridJsComponent.prototype.setServerSideProps = function () {
        if (this.isCSRMEnabled) {
            return;
        }
        this.gridOptions['rowModelType'] = 'serverSide';
        this.gridOptions['serverSideStoreType'] = 'partial';
        this.gridOptions['serverSideInitialRowCount'] = this.config.gridConfig.loaderRowCount || 5;
        this.gridOptions['serverSideDatasource'] = this.dataSource;
        this.gridOptions['maxConcurrentDatasourceRequests'] = 1;
    };
    CsAgGridJsComponent.prototype.setPaginationProps = function () {
        if (this.isPagination) {
            this.gridOptions['pagination'] = true;
            this.gridOptions['paginationPageSize'] = this.paginationParams['pageSize'];
            this.gridOptions['cacheBlockSize'] = this.paginationParams['pageSize'];
        }
    };
    Object.defineProperty(CsAgGridJsComponent.prototype, "focusEnablingClass", {
        get: function () {
            var enablingClass = '';
            var isSpace = function () { return enablingClass ? ' ' : ''; };
            enablingClass += this.config.gridConfig.rowFocus ? (isSpace() + 'cs-enable-row-focus') : '';
            enablingClass += this.config.gridConfig.cellFocus ? (isSpace() + 'cs-enable-cell-focus') : '';
            return enablingClass;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsAgGridJsComponent.prototype, "isPagination", {
        get: function () {
            return !this.isCSRMEnabled && !this.config.hidePagination;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsAgGridJsComponent.prototype, "isCSRMEnabled", {
        get: function () {
            return this.config.gridConfig.enableClientSideRowModel;
        },
        enumerable: true,
        configurable: true
    });
    CsAgGridJsComponent.prototype.resolvedAngularComponents = function () {
        var _this = this;
        if (this.config['customComponents']) {
            var resolvedComponents_1 = {};
            Object.entries(this.config.customComponents).forEach(function (_a) {
                var name = _a[0], component = _a[1];
                resolvedComponents_1[name] = _this._componentResolver.resolveAngularRendererComponent(component);
            });
            return resolvedComponents_1;
        }
        return null;
    };
    CsAgGridJsComponent.prototype.setRowSelectionConfig = function () {
        if (this.config.gridConfig.rowSelection) {
            this.gridOptions['rowSelection'] = {
                mode: 'multiRow',
                // headerCheckbox: false
                isRowSelectable: this.config.gridConfig.hasOwnProperty("isRowSelectable") ? this.config.gridConfig.isRowSelectable : function () { return true; },
            };
        }
        if (this.config.gridConfig.pinRowSelection) {
            this.gridOptions['selectionColumnDef'] = {
                pinned: this.config.gridConfig.pinRowSelection,
            };
        }
    };
    CsAgGridJsComponent.prototype.setDetailGridConfig = function () {
        var _this = this;
        if (this.config.gridConfig.enableDetailGrid && this.config.detailGridConfig) {
            var detailConfig = this.config.detailGridConfig;
            var paramsCb_1 = detailConfig.params;
            var rendererCb_1 = detailConfig.renderer;
            // const heightCb = detailConfig.gridHeight;
            this.gridOptions['detailCellRenderer'] = function (rendererParams) {
                var detailMetaData = rendererParams.node.parent['detailMetaData'];
                // const detailHeight: ICsDetailGridHeightObject | number = heightCb ? heightCb(detailMetaData) : 310;
                var detailRenderer = rendererCb_1 ? rendererCb_1(detailMetaData) : 'detailGridRenderer';
                var RendererClass = _this.gridOptions.components[detailRenderer];
                var instance = new RendererClass();
                var rowId = (rendererParams.node.id || rendererParams.node.rowIndex).replace("detail_", "");
                _this.gridApiMap.set(rowId, _this.gridApi);
                rendererParams['currentParent'] = _this.params && _this.params['parentTree']
                    ? _this.params['parentTree'].concat([{ api: _this.gridApi, rowId: rowId, config: _this.config }]) : [{ api: _this.gridApi, rowId: rowId, config: _this.config }];
                instance.init(rendererParams);
                // const rowNodes = this.getDisplayedRowNodes(rendererParams.api) || [];
                //
                // const computedHeight = typeof detailHeight == 'number' ? detailHeight : Math.min(
                //     (detailHeight.topBarHeight || 0) + detailHeight.headerHeight + (detailHeight.padding || 0) + rowNodes.length * detailHeight.rowHeight,
                //     detailHeight.maxHeight
                // );
                // setTimeout(() => {
                //     rendererParams.node.setRowHeight(computedHeight);
                //     rendererParams.api.onRowHeightChanged();
                // });
                return instance.getGui();
            };
            this.gridOptions['detailCellRendererParams'] = function (params) {
                return { config: paramsCb_1(params.node.parent['detailMetaData']) };
            };
        }
    };
    CsAgGridJsComponent.prototype.setGridLicense = function () {
        window.agGrid.LicenseManager.setLicenseKey(environment.agGridEnterpriseLicenseKey);
    };
    CsAgGridJsComponent.prototype.createGrid = function () {
        // Step 1: Check if agGrid exists
        var agGrid = window.agGrid;
        // Step 2: Log current status for debugging
        var status = this._scriptHandler.getScriptStatus();
        // Step 3: Verify agGrid and createGrid exist
        if (!agGrid) {
            this.reloadScriptAndCreateGrid();
            return;
        }
        if (!agGrid.createGrid) {
            this.reloadScriptAndCreateGrid();
            return;
        }
        // Step 4: Verify grid element exists
        if (!this.grid || !this.grid.nativeElement) {
            return;
        }
        // Step 5: Create grid
        try {
            this.gridApi = agGrid.createGrid(this.grid.nativeElement, this.gridOptions);
            if (!this.gridApi) {
                return;
            }
            this.onGridInit.emit(this.gridInstance);
            // this.updateDragListenersToHeaders();
            // this.observeGridContainerResize();
        }
        catch (error) {
            console.error('Error creating grid:', error);
            this.reloadScriptAndCreateGrid();
        }
    };
    CsAgGridJsComponent.prototype.reloadScriptAndCreateGrid = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status_1, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // Reset the script handler state to allow reload
                        this._scriptHandler.resetScriptState();
                        return [4 /*yield*/, this._scriptHandler.loadAgGridScript()];
                    case 1:
                        _a.sent();
                        status_1 = this._scriptHandler.getScriptStatus();
                        if (this._scriptHandler.isScriptLoaded()) {
                            this.createGrid();
                        }
                        else {
                            console.error('Script still not loaded after reload attempt');
                            // Only reload page as last resort
                            setTimeout(function () {
                                window.location.reload();
                            }, 2000);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Failed to reload script:', error_1);
                        setTimeout(function () {
                            window.location.reload();
                        }, 2000);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add this public method for debugging
    CsAgGridJsComponent.prototype.verifyAgGridLoaded = function () {
        var agGrid = window.agGrid;
        var status = {
            windowAgGrid: !!agGrid,
            createGrid: !!(agGrid && agGrid.createGrid),
            gridElement: !!(this.grid && this.grid.nativeElement),
            scriptStatus: this._scriptHandler.getScriptStatus()
        };
        return !!(agGrid && agGrid.createGrid);
    };
    Object.defineProperty(CsAgGridJsComponent.prototype, "dataSource", {
        get: function () {
            var _this = this;
            return ({ getRows: function (params) { return _this.setGridData(params); } });
        },
        enumerable: true,
        configurable: true
    });
    CsAgGridJsComponent.prototype.setCSRMData = function () {
        if (this.isCSRMEnabled) {
            this.setGridData();
        }
    };
    Object.defineProperty(CsAgGridJsComponent.prototype, "gridInstance", {
        get: function () {
            return {
                refreshGridData: this.refreshGridData,
                addOnData: this.getAddOnData,
                getSelectedRows: this.getSelectedRows,
                resetPagination: this.resetPagination,
                // refreshHeaders: this.updateDragListenersToHeaders.bind(this),
                gridApi: this.gridApi
            };
        },
        enumerable: true,
        configurable: true
    });
    CsAgGridJsComponent.prototype.isDisable = function (action) {
        return typeof action.disable === 'function' ? action.disable() : action.disable;
    };
    CsAgGridJsComponent.prototype.isHide = function (action) {
        return typeof action.hide === 'function' ? action.hide() : action.hide;
    };
    CsAgGridJsComponent.prototype.updateSwappingRowClasses = function (event, rowElement, rowIndex) {
        var totalRows = event.api.getDisplayedRowCount();
        totalRows = totalRows > this.paginationParams.pageSize ? this.paginationParams.pageSize : totalRows;
        this.renderer[rowIndex === 0 ? 'addClass' : 'removeClass'](rowElement, 'ag-row-first');
        this.renderer[rowIndex === (totalRows - 1) ? 'addClass' : 'removeClass'](rowElement, 'ag-row-last');
        this.renderer.addClass(rowElement, (rowIndex % 2) === 0 ? 'ag-row-even' : 'ag-row-odd');
        this.renderer.removeClass(rowElement, (rowIndex % 2) === 0 ? 'ag-row-odd' : 'ag-row-even');
    };
    CsAgGridJsComponent.prototype.onRowDropped = function (event) {
        var _this = this;
        if (this.config.gridConfig.rowReOrder) {
            var swappedRows = this.getDisplayedRowNodes(event.api)
                .filter(function (rowNode) { return 'swappedOrder' in rowNode.data; })
                .map(function (rowNode) { return ({ id: rowNode.data['id'], order: rowNode.data['swappedOrder'] }); })
                .sort(function (current, next) { return current['order'] > next['order'] ? 1 : (current['order'] < next['order'] ? -1 : 0); });
            if (swappedRows.length) {
                this.config.gridConfig
                    .updateRowOrder(swappedRows)
                    .subscribe(function (res) { return _this.refreshGridData(); });
            }
        }
    };
    CsAgGridJsComponent.prototype.rowSelection = function (event) {
        if (event.source === 'uiSelectAll') {
            return;
        }
        var eventParam = {
            data: event.data,
            isSelected: event.node.isSelected()
        };
        var selectionCb = this.config.gridConfig.onRowSelection;
        selectionCb ? selectionCb(this.gridInstance, eventParam) : this.onRowSelection.emit(eventParam);
    };
    CsAgGridJsComponent.prototype.allRowSelection = function (event) {
        if (['apiSelectAll', 'checkboxSelected'].includes(event.source)) {
            return;
        }
        var allSelectionCb = this.config.gridConfig.onAllRowSelection;
        allSelectionCb ? allSelectionCb(this.gridInstance) : this.onAllRowSelection.emit();
    };
    Object.defineProperty(CsAgGridJsComponent.prototype, "isHeaderActionsAvailable", {
        get: function () {
            var _this = this;
            return !!(this.config.headerPanelConfig.actions.length
                && this.config.headerPanelConfig.actions.find(function (action) { return !_this.isHide(action); }));
        },
        enumerable: true,
        configurable: true
    });
    CsAgGridJsComponent.prototype.onActionClick = function (action) {
        if (this.isDisable(action)) {
            return;
        }
        action.onClick({ action: action.id });
    };
    CsAgGridJsComponent.prototype.onSearch = function (val) {
        this.searchText = val;
        this.resetPagination();
        this.refreshGridData();
    };
    CsAgGridJsComponent.prototype.onFilter = function (param, action) {
        if (action === 'apply') {
            this.appliedFilter.push(param);
        }
        else if (action === 'remove') {
            this.appliedFilter.splice(param, 1);
        }
        else if (action === 'update') {
            var index = param['index'];
            delete param['index'];
            this.appliedFilter[index] = param;
        }
        this.resetPagination();
        this.refreshGridData();
    };
    CsAgGridJsComponent.prototype.updatePagingParams = function (params) {
        this.paginationParams = params;
        if (params.currentEvent && params.currentEvent !== 'none') {
            this.gridApi.setGridOption('paginationPageSize', this.paginationParams.pageSize);
            this.gridApi.setGridOption('cacheBlockSize', this.paginationParams.pageSize);
            this.goToPage();
            this.refreshGridData();
        }
    };
    CsAgGridJsComponent.prototype.goToPage = function (page) {
        if (this.isPagination) {
            if (page) {
                this.paginationParams.currentPage = page;
            }
            this.gridApi.paginationGoToPage(this.paginationParams.currentPage);
        }
    };
    CsAgGridJsComponent.prototype.updateDomLayout = function () {
        var gridEl = this.grid.nativeElement;
        var gridViewportEl = gridEl.querySelector('.ag-body-viewport .ag-viewport.ag-center-cols-viewport');
        if (!gridViewportEl) {
            return;
        }
        var containerHeight = gridEl.clientHeight;
        var headerHeight = this.gridApi.getSizesForCurrentTheme().headerHeight;
        var headerBorderWidth = 1;
        var gridHeight = headerHeight + headerBorderWidth + gridViewportEl.offsetHeight;
        var domLayout = gridHeight > containerHeight ? 'normal' : 'autoHeight';
        if (domLayout !== this.gridLayout) {
            this.gridApi.setGridOption('domLayout', domLayout);
            this.gridLayout = domLayout;
        }
        if (this.params) {
            var defaultRowHeight = 310;
            var rowNodes = this.getDisplayedRowNodes(this.gridApi);
            var detailHeight = this.params.config.gridHeight && rowNodes.length ? this.params.config.gridHeight : defaultRowHeight;
            var computedHeight = typeof detailHeight == 'number' ? detailHeight : Math.min((detailHeight.topBarHeight || 0) + detailHeight.headerHeight + (detailHeight.padding || 0) + rowNodes.length * detailHeight.rowHeight, detailHeight.maxHeight);
            // const detailGridFound = rowNodes.find((node) => node.detail === true);
            // this.sendParentNode.emit(detailGridFound);
            if (this.params.parentTree.length == 2 && this.gridComputedHeight !== computedHeight - 42) {
                var parentBeforeRowNode = this.params.parentTree[1];
                var parentBeforeRowNodes = this.getDisplayedRowNodes(parentBeforeRowNode.api);
                var count = parentBeforeRowNodes.filter(function (node) {
                    var id = node.id;
                    return typeof id === 'string' && !id.includes('detail_');
                }).length;
                var parentDetailHeight = parentBeforeRowNode.config.gridHeight && rowNodes.length ? parentBeforeRowNode.config.gridHeight : defaultRowHeight;
                var parentComputedHeight = typeof parentDetailHeight == 'number' ? parentDetailHeight : (parentDetailHeight.topBarHeight || 0) + parentDetailHeight.headerHeight + (parentDetailHeight.padding || 0) + count * parentDetailHeight.rowHeight;
                var parentHeight = typeof parentDetailHeight == 'number' ? parentDetailHeight : Math.min(((computedHeight * (parentBeforeRowNodes.length - count)) + parentComputedHeight), parentDetailHeight.maxHeight);
                var grandParentRowNode = this.params.parentTree[0];
                grandParentRowNode.api.getRowNode('detail_' + grandParentRowNode.rowId).setRowHeight(parentHeight);
                grandParentRowNode.api.onRowHeightChanged();
                this.params.node.setRowHeight(computedHeight);
                this.params.api.onRowHeightChanged();
            }
            else if (this.params.parentTree.length == 1 && this.gridComputedHeight !== computedHeight) {
                this.params.node.setRowHeight(computedHeight);
                this.params.api.onRowHeightChanged();
            }
            this.gridComputedHeight = computedHeight;
        }
    };
    CsAgGridJsComponent.prototype.setGridData = function (params) {
        var _this = this;
        var requestParams = {
            searchText: this.searchText,
            filters: this.appliedFilter ? JSON.stringify(this.appliedFilter) : null
        };
        if (!this.isCSRMEnabled && params) {
            requestParams['page'] = this.isPagination ? (this.paginationParams.currentPage || 1) : null;
            requestParams['limit'] = this.paginationParams.pageSize;
            requestParams['sort'] = params.request.sortModel[0] ? JSON.stringify(params.request.sortModel[0]) : null;
            requestParams['groupKeys'] = params.request.groupKeys ? JSON.stringify(params.request.groupKeys) : null;
            requestParams['rowGroupCols'] = params.request.rowGroupCols
                ? JSON.stringify(params.request.rowGroupCols.map(function (item) { return item['field']; }))
                : null;
        }
        this.gridList$ = this.config.gridConfig.gridList({ reqParams: requestParams })
            .subscribe(function (res) {
            _this.totalRecords = +res[_this.config.gridConfig.dataResKeys.countKey];
            var data = res[_this.config.gridConfig.dataResKeys.dataKey];
            _this.gridListAddOnData = tslib_1.__assign({}, res['addOnData'], { displayRecordCount: data.length });
            if (_this.isCSRMEnabled) {
                _this.showOrHideNoRowsOverlay(!_this.totalRecords);
                _this.gridApi.setGridOption('rowData', data);
            }
            else {
                var isPartialRecordsInPage = data.length < requestParams['limit'];
                var recordCount = isPartialRecordsInPage ? data.length : _this.totalRecords;
                _this.showOrHideNoRowsOverlay(!recordCount);
                params.success({ rowData: data, rowCount: recordCount });
            }
            _this.isDataLoading = false;
            _this.config.gridConfig.onGridDataLoad ?
                _this.config.gridConfig.onGridDataLoad(_this.gridInstance)
                : _this.onGridDataLoad.emit(_this.gridInstance);
        });
    };
    CsAgGridJsComponent.prototype.resetSelectedRows = function () {
        if (this.config.gridConfig.rowSelection) {
            this.gridApi.deselectAll();
        }
    };
    CsAgGridJsComponent.prototype.ngOnDestroy = function () {
        if (this.gridList$) {
            this.gridList$.unsubscribe();
        }
        this._scriptHandler.removeAgGridScript();
    };
    return CsAgGridJsComponent;
}());
export { CsAgGridJsComponent };
